const limeA = {
  limeA1: "hsla(80, 93.8%, 31.4%, 0.020)",
  limeA2: "hsla(85, 99.3%, 40.2%, 0.059)",
  limeA3: "hsla(84, 98.7%, 43.2%, 0.138)",
  limeA4: "hsla(84, 99.6%, 43.0%, 0.220)",
  limeA5: "hsla(85, 99.8%, 41.8%, 0.310)",
  limeA6: "hsla(82, 99.8%, 39.3%, 0.420)",
  limeA7: "hsla(79, 99.7%, 34.6%, 0.585)",
  limeA8: "hsla(76, 99.8%, 33.7%, 0.828)",
  limeA9: "hsla(81, 99.8%, 40.2%, 0.836)",
  limeA10: "hsla(80, 100%, 37.6%, 0.851)",
  limeA11: "hsla(75, 99.5%, 22.0%, 0.950)",
  limeA12: "hsla(78, 99.6%, 8.4%, 0.965)"
};
export { limeA };
//# sourceMappingURL=limeA.mjs.map
